import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface ListEventDirections {
	uriParams: Api.Operations['listEventDirections']['parameters']['path']
	params?: Api.Operations['listEventDirections']['parameters']['query']
	response: Api.Operations['listEventDirections']['responses']['200']['content']['application/json']
}

export const listEventDirections = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ListEventDirections>(
		{
			method: 'get',
			url: '/events/{eventId}/directions',
			...overideConfig,
		},
		axiosInstance,
	)
